import styled, { css } from 'styled-components';
const modalMobileBreakpoint = 768;
export const ModalWrapper = styled.div `
  ${props => props.forceFullscreen ? `
    --modal-outer-padding: 0;
    --modal-inner-padding: 20px;
  ` : `
    --modal-outer-padding: ${props.outerPadding}px;
    --modal-inner-padding: ${props.noInternalPadding ? '0' : props.innerPadding + 'px'};

    @media screen and (max-width: ${modalMobileBreakpoint}px) {
      --modal-outer-padding: ${props.noMobileFullscreen ? '5px' : '0'};
      --modal-inner-padding: ${props.noInternalPaddingMobile ? '0' : props.innerPadding + 'px'};
    }
  `}

  height: 100%;
  left: 0;
  overflow: hidden;
  position: fixed;
  top: 0;
  ${props => props.opened ? `
    opacity: 1;
  ` : `
    opacity: 0;
    user-select: none;
    visibility: hidden;
  `}
  width: 100%;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
`;
export const ModalWrapperInner = styled.div `
  padding: var(--modal-outer-padding);
  overflow: auto;
  width: 100%;
  height: 100%;
`;
export const ModalWrapperInnerInner = styled.div `
  display: flex;
  align-items: center;
  min-height: 100%;
`;
export const ModalWrapperInnerInnerInner = styled.div `
  display: flex;
  align-items: center;

  ${props => (!props.noMobileFullscreen) && `@media screen and (max-width: ${modalMobileBreakpoint}px) {
    min-height: calc(100vh - 2 * var(--modal-inner-padding));
  }`}

  > * {
    width: 100%;
  }
`;
const modalInnerForceFullscreen = css `
  min-height: 100vh;
  max-width: none;
`;
export const ModalInner = styled.div `
  background-color: ${props => props.theme.colors.white};
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  position: relative;
  width: 100%;
  max-width: ${props => props.width ? props.width + 'px' : '670px'};
  ${props => props.minHeight ? `min-height: ${props.minHeight}px;` : ''}
  transform-origin: center;
  padding: var(--modal-inner-padding);
  margin: 0 auto;
  ${props => props.forceFullscreen ? modalInnerForceFullscreen : `
    ${(!props.noMobileFullscreen) ? `@media screen and (max-width: ${modalMobileBreakpoint}px) {
      ${modalInnerForceFullscreen}
    }` : ``}
  `}
`;
export const CloseButton = styled.div `
  position: absolute;
  top: 20px;
  right: 20px;
  width: 18px;
  height: 18px;
  background-image: url("data:image/svg+xml,%3Csvg data-name='Warstwa 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15 15'%3E%3Cpath fill='%23121212' d='M15 14.28L8.22 7.5 15 .72 14.28 0 7.5 6.78.72 0 0 .72 6.78 7.5 0 14.28l.72.72L7.5 8.22 14.28 15l.72-.72z'/%3E%3C/svg%3E");
  cursor: pointer;
  z-index: 9999;

  &:active {
    margin-top: 2px;
  }
`;
export const BackButton = styled.a `
  display: flex;
  font-size: 15px;
  cursor: pointer;
  align-items: center;

  span {
    margin-left: 12px;
  }
`;
export const MobileTitleWrapper = styled.div `
  position: fixed;
  background: #fff;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  padding: 0;
  height: 47px;
  border-bottom: 1px solid #cbcbcb;
  text-align: center;

  > * {
    margin: 0;
    position: static;
  }

  h2 {
    font-size: 18px;
    line-height: 45px;
    font-weight: 700;
    font-style: normal;
    margin: 0 auto -1px;
    border-bottom: 2px solid ${props => props.theme.colors.primary};
  }

  ${CloseButton} {
    position: absolute;
    right: 13px;
    top: 13px;
  }

  ${BackButton} {
    position: absolute;
    left: 13px;
    top: 13px;
  }
`;
